export class TransactionHistory{
    id:number;
    invoiceCode:string;
    transactionId:string;
    shipmentNumber:string;
    orderDate:any;
    paidTime:any;
    description:string;
    descriptionResponse:string;
    transactionStatusName:string;
    receiverCode:string;
    receiverName:string;
    shippingAddress:string;
    shippingAddressNew:string;
    senderCode:string;
    senderName:string;
    fullName:string;
    shipmentStatusName:string;
    totalPrice:number;
    cod:number;
    amount:number;
    paymentTypeName:string;
    colorType:number;
}